import React from "react";
import ReactDOM from "react-dom/client";
import "typeface-poppins";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { TripFiltersProvider } from "./context/trip-filters.context";
import { UserProvider } from "./context/user.context";
import { CheckoutProvider } from "./context/checkout.context";
import { CompareProvider } from "./context/compare.context";
import CssBaseline from "@mui/material/CssBaseline";
import GlobalStyles from "@mui/material/GlobalStyles";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./theme";
import initSentry from "./config/sentry.config";

// Initialize Sentry for error tracking
initSentry();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {/* Rede de segurança: impede que qualquer elemento que estoure a largura
          gere barra de rolagem horizontal (crítico no mobile). Usa "clip" e não
          "hidden" para não quebrar elementos fixos ao rolar (position: sticky). */}
      <GlobalStyles styles={{ "html, body": { overflowX: "clip", maxWidth: "100%" } }} />
      <BrowserRouter>
        <UserProvider>
          <CheckoutProvider>
            <TripFiltersProvider>
              <CompareProvider>
                <App />
              </CompareProvider>
            </TripFiltersProvider>
          </CheckoutProvider>
        </UserProvider>
      </BrowserRouter>
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
